<template>
  <div class="material-list">
    <div class="content-header"></div>
    <div class="content-wrapper">
      <SearchRow
        ref="searchRow"
        @onFilter="handleFilter"
        @onReset="handleReset"
      />
      <div class="content-list">
        <el-table
          v-loading="listLoading"
          border
          :data="materialList"
          :header-cell-style="{
            color: 'rgba(13, 13, 13, 85)',
            'text-align': 'center',
          }"
        >
          <el-table-column label="物料编码" align="center" prop="itemCode" />
          <el-table-column label="物料名称" align="center" prop="itemName" />
          <el-table-column label="质保期" align="center" prop="underWarranty" />
          <el-table-column label="单位" align="center" prop="itemUnit" />
          <el-table-column label="状态" align="center" width="150">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                class="primary putaway"
                size="small"
                :plain="row.itemStatus !== 1"
                @click="handleStatus(row, 'putaway')"
                >上架</el-button
              >
              <el-button
                type="primary"
                class="primary sold-out"
                size="small"
                :plain="row.itemStatus !== -1"
                @click="handleStatus(row, 'soldOut')"
                >下架</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                plain
                icon="el-icon-edit"
                size="mini"
                @click="handleEdit(row)"
                >编辑</el-button
              >
              <el-button
                type="primary"
                plain
                icon="el-icon-delete"
                size="mini"
                @click="handleDatele(row)"
                >删除</el-button
              >
              <el-button
                type="primary"
                plain
                size="mini"
                @click="handlePriceControl(row)"
                >价格管理</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="content-pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :current-page="queryParams.page"
            :page-size="queryParams.pageSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="hint">
        {{ messageDialog }}
      </div>
      <span slot="footer" class="dialog-footer">
        <template
          v-if="
            operatingBtnType !== 'undetele' &&
            operatingBtnType !== 'stopPutaway'
          "
        >
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleConfirm">确定</el-button>
        </template>
        <el-button v-else type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SearchRow from './components/search-row'
import bccApi from '@/api/bcc'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  name: 'material-list',
  components: {
    SearchRow
  },
  data () {
    return {
      listLoading: false,
      total: 10,
      materialList: [],
      dialogVisible: false,
      operatingBtnType: '', // detele删除 undetele删除物料被引用  putaway上架  soldOut下架 stopPutaway上架价格为空
      operatingRow: null,
      queryParams: {
        itemName: '',
        itemCode: '',
        page: 1,
        pageSize: 10
      },
      editRules:{
        
      }
    }
  },
  computed: {
    successfulTip () {
      const obj = {
        detele: '删除',
        putaway: '上架',
        soldOut: '下架'
      }
      return obj[this.operatingBtnType] || ''
    },
    messageDialog () {
      const { itemCode = '' } = this.operatingRow || {}
      const obj = {
        detele: `是否确定要将物料编码为${itemCode}"的物料删除？`,
        undetele: '该物料已被引用，无法删除',
        putaway: `是否确定上架此物料（物料编码${itemCode}）？`,
        soldOut: `是否确定下架此物料（物料编码${itemCode}）？`,
        stopPutaway: '请至少配置一项价格区域'
      }
      return obj[this.operatingBtnType] || ''
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'material-info' || to.name === 'price-control') {
      localStorageUtils.set('bccMaterialQueryParams', JSON.stringify(this.queryParams))
    } else {
      localStorageUtils.remove('bccMaterialQueryParams')
    }
    next()
  },

  watch: {
    '$route': {
      handler (to, from) {
        this.getQueryParams()
      },
      immediate: true
    }
  },
  methods: {
    getQueryParams () {
      if (localStorageUtils.get('bccMaterialQueryParams')) {
        this.queryParams = JSON.parse(localStorageUtils.get('bccMaterialQueryParams'))
        this.$nextTick(() => {
          this.$refs.searchRow.setUserParams(this.queryParams)
        })
      }
      this.getTradeItemList()
      localStorageUtils.remove('bccMaterialQueryParams')
    },
    // 获取列表
    async getTradeItemList () {
      this.listLoading = true
      const { data } = await bccApi.getTradeItemList(this.queryParams)
      this.listLoading = false
      if (data.resultCode === '0') {
        this.materialList = data.resultData?.tradeItemList || []
        this.total = data.resultData.pageInfo.totalCounts
      }
    },

    // 搜索
    handleFilter (val) {
      this.queryParams = Object.assign(this.queryParams, val)
      this.queryParams.page = 1
      this.getTradeItemList()
    },

    // 重置
    handleReset () {
      this.queryParams = this.$options.data().queryParams
      this.getTradeItemList()
    },

    // 分页
    handleCurrentChange (val) {
      this.queryParams.page = val
      this.getTradeItemList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getTradeItemList()
    },

    // 删除上下架弹框确认
    handleConfirm () {
      if (this.operatingBtnType === 'detele') {
        this.deleteTradeItem()
        return
      }
      this.setTradeItem()
    },

    // 删除按钮---查询物料是否被引用
    async handleDatele (row) {
      const { data } = await bccApi.queryMaterialCited(row.tradeItemId)
      if (data.resultCode === '0') {
        if (data.resultData.counts >= 1) {
          this.operatingBtnType = 'undetele'
        } else {
          this.operatingBtnType = 'detele'
          this.operatingRow = row
        }
      }
      this.dialogVisible = true
    },

    // 删除
    async deleteTradeItem () {
      const { data } = await bccApi.deleteTradeItem(
        this.operatingRow.tradeItemId
      )
      if (data.resultCode === '0') {
        this.$message.success(`${this.successfulTip}成功`)
        this.getTradeItemList()
      }
      this.dialogVisible = false
    },

    // 上下架按钮
    handleStatus (row, status) {
      const itemStatus = status === 'putaway' ? 1 : -1
      if (row.itemStatus === itemStatus) return
      if (status === 'putaway') {
        this.checkMaterialPublish(row)
        return
      }
      this.operatingBtnType = status
      this.operatingRow = row
      this.dialogVisible = true
    },

    // 上架时校验价格是否全是空
    async checkMaterialPublish (row) {
      const { data } = await bccApi.checkMaterialPublish(row.tradeItemId)
      if (data.resultCode === '0') {
        if (data.resultData.canUpload < 1) {
          this.operatingBtnType = 'stopPutaway'
        } else {
          this.operatingBtnType = 'putaway'
          this.operatingRow = row
        }
      }
      this.dialogVisible = true
    },

    // 上下架
    async setTradeItem () {
      const api =
        this.operatingBtnType === 'putaway'
          ? 'publishTradeItem'
          : 'offlineTradeItem'
      const { data } = await bccApi[api](this.operatingRow.tradeItemId)
      if (data.resultCode === '0') {
        this.$message.success(`${this.successfulTip}成功`)
        this.getTradeItemList()
      }
      this.dialogVisible = false
    },

    // 价格管理
    handlePriceControl (row) {
      this.$router.push({
        path: '/bcc/price/control',
        query: {
          itemCode: row.tradeItemId
        }
      })
    },

    // 编辑
    handleEdit (row) {
      this.$router.push({
        path: '/bcc/material/info',
        query: {
          type: 'edit',
          itemCode: row.tradeItemId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url("../../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}
.content-list {
  margin-top: $content-middle;
}
.content-pagination {
  text-align: center;
  margin-top: $content-large;
}
</style>
<style lang="scss">
.material-list {
  .el-button--primary.is-plain {
    background: #ffff;
    color: #409eff;
  }
  .el-button--primary.is-plain:hover,
  .el-button--primary.is-plain:active {
    background: #409eff;
    color: #fff;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: 0;
    .el-button {
      width: 70px;
    }
  }
  .primary {
    margin-left: 0;
    border-radius: 0;
  }
  .putaway {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .sold-out {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .hint {
    text-align: center;
    font-size: $font-16;
  }
}
</style>
